module.exports = __webpack_public_path__ + "static/media/support.199777e3.svg";